import { render, staticRenderFns } from "./DiscountCoupons.vue?vue&type=template&id=64c2eb7a&scoped=true&"
import script from "./DiscountCoupons.vue?vue&type=script&lang=js&"
export * from "./DiscountCoupons.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCoupons.vue?vue&type=style&index=0&id=64c2eb7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2eb7a",
  null
  
)

export default component.exports